
import { Store } from '../types';

export const stores: Store[] = [
    {
        id: 1,
        name: 'Taurus Armas S.A.',
        logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Taurus_Armas_logo.svg/1200px-Taurus_Armas_logo.svg.png',
        description: 'Líder mundial na produção de revólveres e uma das maiores produtoras de pistolas, sendo a marca mais importada pelos EUA.',
    },
    {
        id: 2,
        name: 'Glock Store',
        logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Glock_logo.svg/1200px-Glock_logo.svg.png',
        description: 'Loja especializada em pistolas, acessórios e equipamentos da marca Glock. Performance e confiança austríaca.',
    },
    {
        id: 3,
        name: 'Atirador Raiz',
        logoUrl: 'https://i.pravatar.cc/150?u=atiradorraiz',
        description: 'Vendedor particular verificado. Equipamentos para tiro esportivo e defesa, com foco em custo-benefício e atendimento personalizado.',
    }
];
